import { createSelector } from 'reselect';

const selectBusiness = state => state.business;

export default createSelector(
    [selectBusiness],
    business => business
);
